import {history} from "../../utils/history";
import {
  createPreflightUrl,
  StartPreflightSearchParams,
} from "../../pages/page-admin-preflight/route";

import {WorkflowOption} from "./types";

export type NavigateAfterWorkflowSelectArgs = Readonly<{
  facilityId: string;
  workflow: WorkflowOption;
  residentId?: string;
}>;

/**
 * Routes the user after they confirm a workflow in StartWorkflowModal / WorkflowList.
 *
 * TODO: When preflight creation accepts workflowType + residentId server-side, read search
 * params in PageAdminPreflight and pass them into admission draft / link-resident hooks.
 */
export const navigateAfterWorkflowSelect = ({
  facilityId,
  workflow,
  residentId,
}: NavigateAfterWorkflowSelectArgs) => {
  const searchParams: StartPreflightSearchParams = {
    workflowType: workflow.type,
  };

  if (residentId) {
    searchParams.residentId = residentId;
  }

  history.push(createPreflightUrl({facilityId, ...searchParams}));
};
